import {Language} from './language.model';

export class LanguageConfig {

  availableLangs: Array<Language>;
  defaultLang: Language;
}
